module.exports = __webpack_public_path__ + "static/img/bgimg2-3.70317d34.png";